import { Component } from '@angular/core';

@Component({
  selector: 'folding-spinner',
  templateUrl: './folding-spinner.component.html',
  })
export class FoldingSpinnerComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/folding-spinner/folding-spinner.component.ts